export const getIsActual = (reportCreateDate: string, updateDate?: string) => {
  const datetimeRegex = /(\d\d)\.(\d\d)\.(\d\d\d\d)\s(\d\d):(\d\d):(\d\d)/;

  const reportCreateDateArr = datetimeRegex.exec(reportCreateDate);
  const updateDateArr = datetimeRegex.exec(updateDate!);

  if (reportCreateDateArr !== null && updateDateArr !== null) {
    const reportCreateDatetime = new Date(
      Number(reportCreateDateArr[3]),
      Number(reportCreateDateArr[2]),
      Number(reportCreateDateArr[1]),
      Number(reportCreateDateArr[4]),
      Number(reportCreateDateArr[5])
    );

    const updateDatetime = new Date(
      Number(updateDateArr[3]),
      Number(updateDateArr[2]),
      Number(updateDateArr[1]),
      Number(updateDateArr[4]),
      Number(updateDateArr[5])
    );

    return reportCreateDatetime.getTime() >= updateDatetime.getTime();
  }

  return true;
};
